/**
 * Hook to synchronize Okta access token with API services
 * 
 * This hook automatically updates the access token in both the
 * Protocol API service and Agent Gateway service whenever the
 * authentication state changes.
 */

import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { apiService } from '../services/api';
import { agentService } from '../services/agent';
import { extractorService } from '../services/extractor';
import { analysisService } from '../services/analysis';

export const useApiAuth = () => {
  const { authState } = useOktaAuth();

  useEffect(() => {
    // Extract access token from auth state
    const accessToken = authState?.accessToken?.accessToken ?? null;

    // Update all API services with the current token
    apiService.setAccessToken(accessToken);
    agentService.setAccessToken(accessToken);
    extractorService.setAccessToken(accessToken);
    analysisService.setAccessToken(accessToken);

    // Debug logging
    if (process.env.NODE_ENV === 'development') {
      if (accessToken) {
        console.log('[useApiAuth] Access token updated in API services');
      } else {
        console.log('[useApiAuth] Access token cleared from API services');
      }
    }
  }, [authState]);

  return {
    isAuthenticated: authState?.isAuthenticated ?? false,
    accessToken: authState?.accessToken?.accessToken ?? null,
  };
};
